import React, { useMemo } from 'react'
import axios from 'axios'
import { Text } from '@pet-notify/ui'

type ErrorResponse = { errors?: [{ detail: string }] } & { error?: string }

export function parseErrorMessage(error: unknown) {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as ErrorResponse
    if (data.errors?.[0].detail) {
      return data.errors?.[0].detail
    }
    if (data.error) {
      return data.error
    }
  } else if (typeof error === 'string') {
    return error
  }

  return 'Oops, we had an error'
}

function ErrorMessage({ error }: { error: unknown }) {
  const message = useMemo(() => {
    return parseErrorMessage(error)
  }, [error])

  return (
    <Text mb='3' variant='error'>
      {message}
    </Text>
  )
}

export default ErrorMessage
